"use client";
import { useCallback, useRef, useState } from "react";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import LeftArrowNoTail from "@/SvgIcons/LeftArrowNoTail";
import RightArrowNoTail from "@/SvgIcons/RightArrowNoTail";
import styles from "./AmityScholars.module.scss";
import Image from "next/image";



const AmityScholars = ({ Testimonials }: any) => {
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.prevSlide();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.nextSlide();
  }, []);

  const handleSlideChange = ({ isBeginning, isEnd }) => {
    setIsAtStart(isBeginning);
    setIsAtEnd(isEnd);
  };

  return (
    <section className={styles.sectionWrapper}>
      <h2 className={styles.title}>{Testimonials?.Title}</h2>

      <div className={styles.carouselWrapper}>
        <Carousel
          ref={sliderRef}
          config={{
            autoplay: { status: false },
            spaceBetween: 20,
            slidesPerView: 1,
            pagination: { status: false },
            breakpoints: {
              320: { slidesPerView: 1, spaceBetween: 12 },
              768: { slidesPerView: 1, spaceBetween: 20 },
            },
            onSlideChange: ({ isBeginning, isEnd }) =>
              handleSlideChange({ isBeginning, isEnd }),
          }}
          isSmoothBehaviour={true}
          id="amity-scholars-carousel"
        >
          {Testimonials.Details.map((scholar, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.quoteIcon}>
                <Image
                  src="https://static-studyabroad.amityonline.com/dev/quote_Icon_3cd1b4fef1.svg"
                  alt="Quote"
                  width={70}
                  height={70}
                />
              </div>
              <div className={styles.cardContent}>
                <p className={styles.testimonialText}>{scholar?.Description}</p>
                <p className={styles.scholarName}>&#8212; {scholar?.Title}</p>
              </div>
              <div className={styles.profileImageWrapper}>
                <Image
                  src={scholar?.Image?.url}
                  alt={scholar?.Title}
                  width={154}
                  height={154}
                />
              </div>
            </div>
          ))}
        </Carousel>

        <button
          className={styles.prevArrow}
          onClick={handlePrev}
          disabled={isAtStart}
          aria-label="Previous scholar"
        >
          <LeftArrowNoTail />
        </button>
        <button
          className={styles.nextArrow}
          onClick={handleNext}
          disabled={isAtEnd}
          aria-label="Next scholar"
        >
          <RightArrowNoTail />
        </button>
      </div>
    </section>
  );
};

export default AmityScholars;
